import { Component, OnInit } from '@angular/core';

import { CalendarService } from '../../shared/services/calendar.service';
import { Location } from '../../shared/models/location.model';
import { User } from '../../shared/models/user.model';
import { SessionService } from '../../shared/services/session.service';
import { Appointment } from '../../shared/models/appointment.model';
import { Utils } from '../../shared/utils/utils';
import * as moment from 'moment-timezone';
import { environment } from '../../../environments/environment';

@Component({
    templateUrl: 'review-submit.component.html',
    standalone: false
})
export class ReviewSubmitComponent implements OnInit {

    public isIE: boolean = false;
    public appointmentLocation: Location;
    public appointmentDate: Date;
    public appointmentTime: Date;
    public appointmentFor: User;
    public moment: any;
    public new: boolean = false;
    public requireReason: boolean = false;
    public month: string;
    public dayOfWeek: string;

    public isRemoteLocation = false;
    
    public set reason(value:string) {
        this.sessionService.reason = value;
        this.sessionService.appointment.notes = value;
    }

    constructor(private sessionService: SessionService, private calService: CalendarService) {
        this.moment = moment;
    }

    ngOnInit() {
        Utils.scrollUp();
        this.checkForIE();
        this.appointmentLocation = this.sessionService.location;
        this.appointmentDate = this.sessionService.appointmentDate;
        this.dayOfWeek = this.calService.getDayDisplayName(this.appointmentDate);
        this.appointmentTime = this.sessionService.appointmentTime;
        this.appointmentFor = this.sessionService.user;
        this.new = this.sessionService.appointmentType === Appointment.TYPE_CREATE;
        this.requireReason = this.sessionService.requireReason;

        this.month = 'GENERAL_REUSABLE.MONTHS.';
        switch (this.appointmentDate.getMonth() + 1) {
            case 1:
                this.month += 'JANUARY';
                break;
            case 2:
                this.month += 'FEBRUARY';
                break;
            case 3:
                this.month += 'MARCH';
                break;
            case 4:
                this.month += 'APRIL';
                break;
            case 5:
                this.month += 'MAY';
                break;
            case 6:
                this.month += 'JUNE';
                break;
            case 7:
                this.month += 'JULY';
                break;
            case 8:
                this.month += 'AUGUST';
                break;
            case 9:
                this.month += 'SEPTEMBER';
                break;
            case 10:
                this.month += 'OCTOBER';
                break;
            case 11:
                this.month += 'NOVEMBER';
                break;
            case 12:
                this.month += 'DECEMBER';
                break;
        }

        if (this.sessionService.location && this.sessionService.location.id === environment.REMOTE_LOCATION_ID) {
            this.isRemoteLocation = true;
        }
    }
    
    
    private checkForIE() : void {
        let result : any= Utils.detectIE();
        if(result){
            this.isIE = true;
        }        
    }

}
